import { Component, inject, Input } from '@angular/core';
import { magicPreviewDummyData } from '../../../classes/company';
import { DataSharingService } from '../../../services/data-sharing.service';

@Component({
    selector: 'aira-string-list',
    templateUrl: './aira-string-list.component.html',
    styleUrl: './aira-string-list.component.css',
    standalone: false
})
export class AiraStringListComponent {
  @Input() label = '';
  @Input() data: any;
  @Input() headerKeyName = '';
  @Input() contentKeyName = '';
  @Input() previewOnly: boolean = false;

  dataStore = inject(DataSharingService);
  renderData: any[] = [];

  ngOnInit() {
    this.rebuildData();
  }

  ngOnChanges() {
    this.rebuildData();
  }

  rebuildData(): void {
    this.renderData = this.previewOnly
      ? this.replaceDataWithDummyData()
      : (this.data || []);
  }

  replaceDataWithDummyData(): any[] {
    const sourceData = this.data || [];
    const dummyData = sourceData.map((obj, index) => {
      return {
        [this.headerKeyName]: `${magicPreviewDummyData.names[index % magicPreviewDummyData.names.length]}`,
        [this.contentKeyName]:
          `${magicPreviewDummyData.managementRoles[index % magicPreviewDummyData.managementRoles.length]}`,
      };
    });

    return dummyData;
  }
}
